<template>
  <div
    :class="{
      'opacity-50': !animated
    }"
  >
    <div class="wrapper mx-auto" :class="animated ? 'animated' : ''">
      <div
        class="card rounded-5 text-center border-4 h-100 my-auto"
        :class="color"
      >
        <div class="card-body d-flex justify-content-center">
          <div class="my-auto">
            <GroupIcon :index="index" :width="100" :name="name" />
            <div class="fw-bold" :class="`fs-4`">{{ trimmedName }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GroupIcon from "@/components/activity/GroupIcon.vue";

// Data
export default {
  name: "GroupCardPreview",
  components: { GroupIcon },
  props: {
    index: {
      type: Number,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    color: {
      type: String,
      required: true
    },
    animated: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    trimmedName() {
      return this.name.replace("House", "").trim();
    }
  }
};
</script>

<style scoped>
.wrapper {
  position: relative;
  width: 200px;
  height: 200px;
  padding: 3px;
}

@property --angle {
  syntax: "<angle>";
  inherits: false;
  initial-value: 0deg;
}

.card {
  z-index: 1;
  /* border-radius: 50% !important; */
}

.animated::after,
.animated::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  background-image: conic-gradient(
    from var(--angle),
    #ff4545,
    #0f9,
    #006aff,
    #ff0095
  );
  /*
  background-image: conic-gradient(from var(--angle), transparent 30%, #ff00cc);
  background-image: conic-gradient(from var(--angle), transparent 30%, #ff00cc);
  background-image: conic-gradient(from var(--angle), transparent 30%, #ff00cc);
  background-image: conic-gradient(
    from var(--angle),
    transparent 30%,
    rgb(200, 200, 11)
  );
  */
  z-index: 0;
  padding: 0px;
  /* border-radius: 50%; */
  border-radius: 2em;
  animation: 2s spin linear infinite;
}

.animated::before {
  filter: blur(1rem);
  opacity: 0.5;
}

@keyframes spin {
  from {
    --angle: 0deg;
  }
  to {
    --angle: 360deg;
  }
}
</style>
